"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
var getAddr = function getAddr(pId) {
  return new Promise(function (resolve, reject) {
    (0, _requestAuth.default)({
      url: '/sysAddress/getByPId',
      method: 'get',
      params: {
        pId: pId
      }
    }).then(function (res) {
      resolve(res.data);
    });
  });
};
var _default = exports.default = getAddr;